<template>
  <svg
    width="25"
    height="25"
    viewBox="0 0 25 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_1749_33057)">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M14.1514 2.08301C14.7039 2.08313 15.2337 2.3027 15.6243 2.69342L20.2223 7.29134C20.613 7.68195 20.8326 8.21177 20.8327 8.76426V20.833C20.8327 21.3855 20.6132 21.9154 20.2225 22.3061C19.8318 22.6968 19.3019 22.9163 18.7493 22.9163H6.24935C5.69681 22.9163 5.16691 22.6968 4.77621 22.3061C4.38551 21.9154 4.16602 21.3855 4.16602 20.833V4.16634C4.16602 3.61381 4.38551 3.0839 4.77621 2.6932C5.16691 2.3025 5.69681 2.08301 6.24935 2.08301H14.1514ZM12.4993 4.16634H6.24935V20.833H18.7493V10.4163H14.0618C13.6474 10.4163 13.25 10.2517 12.957 9.9587C12.664 9.66567 12.4993 9.26824 12.4993 8.85384V4.16634ZM12.4993 12.4997C13.0273 12.4995 13.5468 12.6331 14.0091 12.888C14.4715 13.143 14.8617 13.5109 15.1434 13.9574C15.4251 14.404 15.5891 14.9146 15.62 15.4417C15.6509 15.9688 15.5477 16.4951 15.3202 16.9715L16.0556 17.708C16.1551 17.8041 16.2344 17.919 16.289 18.0461C16.3436 18.1732 16.3724 18.3099 16.3736 18.4482C16.3748 18.5865 16.3484 18.7237 16.296 18.8517C16.2437 18.9797 16.1663 19.096 16.0685 19.1938C15.9707 19.2916 15.8544 19.369 15.7264 19.4214C15.5984 19.4737 15.4612 19.5001 15.3229 19.4989C15.1846 19.4977 15.0479 19.469 14.9208 19.4144C14.7937 19.3598 14.6788 19.2804 14.5827 19.1809L13.8462 18.4455C13.423 18.6473 12.9598 18.7512 12.4909 18.7497C12.0221 18.7481 11.5596 18.641 11.1377 18.4364C10.7158 18.2318 10.3454 17.9349 10.0539 17.5677C9.76237 17.2005 9.55721 16.7723 9.45363 16.3151C9.35004 15.8578 9.35068 15.3831 9.4555 14.9261C9.56032 14.4691 9.76663 14.0415 10.0591 13.6751C10.3516 13.3086 10.7229 13.0127 11.1453 12.8093C11.5677 12.6058 12.0305 12.5 12.4993 12.4997ZM12.4993 14.583C12.2231 14.583 11.9581 14.6928 11.7628 14.8881C11.5674 15.0835 11.4577 15.3484 11.4577 15.6247C11.4577 15.9009 11.5674 16.1659 11.7628 16.3612C11.9581 16.5566 12.2231 16.6663 12.4993 16.6663C12.7756 16.6663 13.0406 16.5566 13.2359 16.3612C13.4313 16.1659 13.541 15.9009 13.541 15.6247C13.541 15.3484 13.4313 15.0835 13.2359 14.8881C13.0406 14.6928 12.7756 14.583 12.4993 14.583ZM14.5827 4.59759V8.33301H18.3181L14.5827 4.59759Z"
        fill="#444444"
      />
    </g>
    <defs>
      <clipPath id="clip0_1749_33057">
        <rect width="25" height="25" fill="white" />
      </clipPath>
    </defs>
  </svg>
</template>
<script>
  export default {
    name: "reporting",
    props: [],
    data: () => ({}),
    mounted() {},
    methods: {},
  };
</script>

